import { GridContainer } from "../layout";
import { DotGrid } from "../shared/DotGrid";
import { AnimatedSection, scaleFade } from "../shared";
import { Button } from "../ui";
import { analytics } from "../../../lib/analytics";

/**
 * Final CTA section - centered call to action with full-screen treatment.
 * Uses min-h-[80vh] with flexbox centering instead of padding-based spacing.
 */
export function CtaFinal() {
  return (
    <section className="relative z-10 min-h-[80vh] flex items-center justify-center">
      <DotGrid fadeBottom maskIntensity={0.1} />
      <AnimatedSection variants={scaleFade}>
        <GridContainer>
          <div className="col-span-4 md:col-span-8 xl:col-span-12 flex flex-col items-center text-center">
            <span className="text-accent text-sm font-medium tracking-wide uppercase">CONTACT</span>
            <h2 className="mt-4 text-h2-mobile md:text-h1-tablet xl:text-h1 text-text-primary">
              <span className="block">Estructura tu operativa</span>
              <span className="block">para crecer con control.</span>
            </h2>
            <p className="mt-6 text-body text-text-secondary">
              Solicita una demo y descubre cómo Hulahoop Pro puede integrarse en tu modelo de
              trabajo.
            </p>
            <div className="mt-10">
              <a href="/contact" onClick={() => analytics.ctaContact("cta_final")}>
                <Button variant="primary">Book Demo</Button>
              </a>
            </div>
          </div>
        </GridContainer>
      </AnimatedSection>
    </section>
  );
}
